import { get } from '.';

export function GetVehicleMakeDefinitions(options = {}) {
	return get<any>("/app/api/vehicle_make_definitions", options);
}

export function GetDistinctVehicleMakes(options = {}) {
	return get<any>("/app/api/vehicle_make_definitions/distinct", options);
}